import { createRouter, createWebHistory } from "vue-router";
import HomePage from "./pages/HomePage.vue";
import PageNotFound from "./pages/PageNotFound.vue";
import PaymentSuccessPage from "./pages/PaymentSuccessPage.vue";
import PaymentFailPage from "./pages/PaymentFailPage.vue";
import PaymentProcessingPage from "./pages/PaymentProcessingPage.vue";
import TextPage from "./pages/TextPage.vue";
import ProductListPage from "./pages/ProductListPage.vue";
import ProfilePage from "./pages/ProfilePage.vue";
// import CartPage from "./pages/CartPage.vue";
import EmailVerification from "./pages/EmailVerification.vue";
import ProductPage from "./components/ProductPage.vue";
import SupportPage from "./pages/SupportPage.vue";
import PasswordReset from "./pages/PasswordReset.vue";
import ContactUs from "./pages/ContactUs.vue";
// import PostsIndex from "./pages/PostsIndex.vue";
// import PostsShow from "./pages/PostsShow.vue";

const routes = [
  {
    path: "/",
    name: "HomePage",
    component: HomePage,
  },
  {
    path: "/success-payment",
    name: "PaymentSuccessPage",
    component: PaymentSuccessPage,
  },
  {
    path: "/fail-payment",
    name: "PaymentFailPage",
    component: PaymentFailPage,
  },
  {
    path: "/processing-payment",
    name: "PaymentProcessingPage",
    component: PaymentProcessingPage,
  },
  {
    path: "/pages/:id",
    name: "TextPage",
    component: TextPage,
  },
  {
    path: "/contact-us",
    name: "ContactUsPage",
    component: ContactUs,
  },
  // {
  //   path: "/posts",
  //   name: "PostsIndex",
  //   component: PostsIndex,
  // },
  // {
  //   path: "/posts/:slug",
  //   name: "PostsShow",
  //   component: PostsShow,
  // },
  // ,
  {
    path: "/faq",
    name: "SupportPage",
    component: SupportPage,
  },
  {
    path: "/products/:itemType?",
    name: "ProductListPage",
    component: ProductListPage,
    props: true,
  },
  {
    path: "/product/:id",
    name: "ProductPage",
    component: ProductPage,
    props: true,
  },
  {
    path: "/profile/:page?",
    name: "ProfilePage",
    component: ProfilePage,
  },
  {
    path: "/verify-email",
    name: "EmailVerification",
    component: EmailVerification,
  },
  // {
  //   path: "/cart",
  //   name: "CartPage",
  //   component: CartPage,
  // },
  {
    path: "/reset-password",
    name: "PasswordReset",
    component: PasswordReset,
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
